
import React, { useEffect } from 'react'
import AddHeader from '../components/AddHeader/AddHeader'
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import FilterContainer from '../components/FilterContainer/FilterContainer';
import CustomTable from '../components/CustomTable/CustomTable';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import { fetchProducts, toggleinstock } from '../hooks/Products';
// import { fetchProducts } from '../hooks/products';

function Products() {
    const navigate = useNavigate();
    const dispatch=useDispatch()
  const { currentLocal } = useSelector((state) => state.currentLocal);
        const {list:products } = useSelector((state) => state.products);
        
    useEffect(() => {
          dispatch(fetchProducts());
    
    }, [dispatch])
  const handleStatusToggle = (id, currentStatus) => {
  // Replace 'updateProductStatus' with your actual Redux action
  // dispatch(updateProductStatus({ id, status: !currentStatus }));
  console.log(`Toggling product ${id} to ${!currentStatus}`);
  dispatch(toggleinstock(id))
  dispatch(fetchProducts())

};
  const header = [
    { id: "id", numeric: false, disablePadding: true, label: currentLocal.home.ID },
        { id: "image", numeric: true, disablePadding: false, label: currentLocal.home.image },
    { id: "name_en", numeric: true, disablePadding: false, label:  currentLocal.home.namePlaceholder+" "+currentLocal.home.inEN },
    { id: "name_ar", numeric: true, disablePadding: false, label: currentLocal.home.namePlaceholder+" "+currentLocal.home.inAR},
      { id: "ProductCategory", numeric: true, disablePadding: false, label: currentLocal.home.ProductCategory},
    { id: "price", numeric: true, disablePadding: false, label: currentLocal.home.price},
    { id: "priceAfterDiscount", numeric: true, disablePadding: false, label: currentLocal.home.priceAfterDiscount},
    // { id: "stock", numeric: true, disablePadding: false, label: currentLocal.home.inStock},
  
  
    { id: "actions", numeric: true, disablePadding: false, label: currentLocal.home.actions },

  ];
  console.log(products,"products");


const myData = Array.isArray(products) 
  ? products.map((item) => {  console.log(item);
  
  return {
    id: item?.id,
        image:<>
        <div className='w-25'>
          <img src={ item.images[0]?.image}alt=''className='w-50'/>
        </div>
        </> || '---', 

    name_en: item.name_en || '---',
    name_ar: item.name_ar || '---',
    ProductCategory:currentLocal.language === "العربيه" ?  item.category?.name_ar:item?.category?.name_en || '---',
    price: item.price_egp+" "+currentLocal.home.egp || '---',
    priceAfterDiscount: item.discounted_price_egp+" "+currentLocal.home.egp || '---',
    stock:<div className="form-check form-switch "style={{
      width: "75px",
    }}>
        <input
          className="form-check-input w-100"
          type="checkbox"
          role="switch"
          id={`switch-${item.id}`}
          checked={item.in_stock} // or item.status
          onChange={() => handleStatusToggle(item.id, item.is_active)}
          style={{ cursor: 'pointer' }}
        />
        <label className="form-check-label" htmlFor={`switch-${item.id}`}>
          {item.is_active ? currentLocal.home.active : currentLocal.home.inactive}
        </label>
      </div>|| '---',
    actions: (
      <div className='d-flex align-items-center'>
        <div 
          className='d-flex align-items-center' 
          style={{ cursor: "pointer" }} 
          onClick={() => navigate(`/dashboard/edit-product/${item?.id}`)}
        >
          <BorderColorIcon
            sx={{ 
              color: '#6C757D', 
              fontSize: '1rem', 
              marginLeft: '5px',
              marginRight: '5px' // أضف مسافة بسيطة من الجهة الأخرى أيضاً
            }}
          />
          <p className='mb-0' style={{ fontSize: '1rem', color: '#6C757D' }}>
            {currentLocal.home.edit}
          </p>
        </div>
      </div>
    )
  };
}):[]
  return (
    <div className='outlit_bg px-4'>
      <AddHeader
        title={currentLocal.home.products}
        text={currentLocal.home.addproduct}
        handleSubmit={() => navigate("/dashboard/add-product")}
      />
      <FilterContainer
        exportexcel={false}
        searchState={false}
      />
{products.length>0&&
      <div className='mx-4'>
        <CustomTable
          headCells={header}
          rows={myData} />
      </div>
}
    </div>
  )
}

export default Products
